import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { HttpUtils } from '../../../../common/http/http-utils';
import { HttpClient } from '@angular/common/http';
const _ = require('lodash');
const INTERVAL = 2000;

@Injectable()
export class DiceIntegrationService {
    constructor(public http: HttpClient) {
    }

    public createDiceConfigurationConfig(payload, id) {
        let url = HttpUtils.getBaseUrl() + '/hybridity/api/dice/configuration';
        return this.http.post(url, payload);
    };

    public saveDiceConfiguration(payload) {
        payload.apiSecret = btoa(payload.apiSecret)
        let url = HttpUtils.getBaseUrl() + '/hybridity/api/dice/configuration';
        return this.http.put(url, payload);
    };

    public getDiceConfigruation(){
        let url = HttpUtils.getBaseUrl() + '/hybridity/api/dice/configuration';
        return this.http.get(url);
    }

    public uploadDiceData(vcUrl) {
        let url = HttpUtils.getBaseUrl() + '/hybridity/api/dice/upload';
        let payload: any = {
            "vcUrl" : vcUrl
        }
        return this.http.post(url, payload);
    }

    public generateInventoryFileToDownload(vcUrl){
        let url = HttpUtils.getBaseUrl() + '/hybridity/api/dice/download';
        let payload: any = {
            "vcUrl" : vcUrl
        }
        return this.http.post(url, payload);
    }

    public getStatus() {
        let url = HttpUtils.getBaseUrl() + '/hybridity/api/dice/status';
        return this.http.get(url);
    }

}


// WEBPACK FOOTER //
// ./src/app/components/administration-main/dice-integration/dice-integration.service.ts